import {
  PresetQuestionnaireTemplate,
  TprmQuestionnaireModelId,
  TprmQuestionnaireTemplate,
  TprmQuestionnaireTemplateId,
  TprmQuestionnaireTemplateMin,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list(questionnaireModelId: TprmQuestionnaireModelId): Promise<TprmQuestionnaireTemplateMin[]> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates",
    {path: {questionnaire_model_id: questionnaireModelId}},
  );
}

export async function get(
  questionnaireModelId: TprmQuestionnaireModelId,
  questionnaireTemplateId: TprmQuestionnaireTemplateId,
): Promise<TprmQuestionnaireTemplate> {
  return platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/{questionnaire_template_id}",
    {path: {questionnaire_model_id: questionnaireModelId, questionnaire_template_id: questionnaireTemplateId}},
  );
}

export async function delete_(
  questionnaireModelId: TprmQuestionnaireModelId,
  questionnaireTemplateId: TprmQuestionnaireTemplateId,
): Promise<void> {
  await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/{questionnaire_template_id}",
    {path: {questionnaire_model_id: questionnaireModelId, questionnaire_template_id: questionnaireTemplateId}},
  );
  await invalidateQueries([q.tprm.questionnaireTemplates.filter()]);
}

export async function updateName(
  questionnaireModelId: TprmQuestionnaireModelId,
  questionnaireTemplateId: TprmQuestionnaireTemplateId,
  name: string,
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/{questionnaire_template_id}/name",
    {
      path: {questionnaire_model_id: questionnaireModelId, questionnaire_template_id: questionnaireTemplateId},
      body: name,
    },
  );
  await invalidateQueries([
    q.tprm.questionnaireTemplate.filter(questionnaireModelId, questionnaireTemplateId),

    q.tprm.questionnaireTemplates.filter(),
  ]);
  return res;
}

export async function createFromPreset(
  questionnaireModelId: TprmQuestionnaireModelId,
  templates: PresetQuestionnaireTemplate[],
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/questionnaire_models/{questionnaire_model_id}/questionnaire_templates/create_from_preset",
    {path: {questionnaire_model_id: questionnaireModelId}, body: templates},
  );
  await invalidateQueries([q.tprm.questionnaireTemplates.filter()]);
  return res;
}
